import $ from 'jquery';
import moment from 'moment';

$(() => {
    const startDate = $('input#startDate');
    const endDateInput = $('input[name="caseBean.endDate"]');
    let endDate;

    const parent = endDateInput.closest('.date-picker');

    if (parent.length > 0) {
        endDate = parent;
    } else {
        console.warn('Parent does not have the datepicker class');
        return; // Exit if the parent doesn't have the required class
    }

    // Initial check in case the start date is pre-filled
    if (startDate.val().length > 0) {
        updateDateConstraints(startDate.val());
    }

    // Event listener for changes on the start date input
    startDate.on('change', function(e) {
        const newStartDate = $(this).val();
        updateDateConstraints(newStartDate);
    });

    function updateDateConstraints(startDateVal) {
        if (startDateVal.length > 0) {
            const startDate = moment(startDateVal, "DD/MM/YYYY").format('YYYY-MM-DD');
            const maxDate = moment(startDateVal, "DD/MM/YYYY").add(5, 'years').format('YYYY-MM-DD');

            endDate.attr('data-min-date', startDate);
            endDate.attr('data-max-date', maxDate);
        }
    }
});
